/*@ngInject*/
const PolicyActionUtil = function ($rootScope, coreConstant, submissionConstant,
                                                  uiPerformanceLoggerConstant, loadingBarHandler,
                                                  policyActionsMediator, umModalUtil) {

    this.cancel = function (policyId) {
        var action = uiPerformanceLoggerConstant.START_POLICY_CANCELLATION,
            message = policyId.toString(),
            promise;

        function onSuccess() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
        }

        loadingBarHandler.showLoadingBar('submission.policy.cancel');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = policyActionsMediator.startPolicyCancellation(policyId).then(onSuccess, onError).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.reinstatePolicy = function (submissionId, policyId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'Reinstatement Reasons', 'submission.reinstateModal',
            false, uiPerformanceLoggerConstant.REINSTATE_POLICY, handleClose);
        function handleClose(result) {
            let promise = policyActionsMediator.reinstatePolicy(policyId, result.reason, result.details).finally(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.startEndorsement = function (policyId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.endorsement.creatingEndorsementLoadingBar');

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise =  policyActionsMediator.startEndorsement(policyId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.startPolicyRewrite = function (policyId) {
        loadingBarHandler.showLoadingBar('submission.policyRewrite.creatingPolicyRewriteLoadingBar');

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        const promise =  policyActionsMediator.startPolicyRewrite(policyId, false /* isReissue */).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.startPolicyReissue = function (policyId) {
        loadingBarHandler.showLoadingBar('submission.policyReissue.creatingPolicyRewriteLoadingBar');

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        const promise =  policyActionsMediator.startPolicyRewrite(policyId, true /* isReissue */).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

};

angular.module('gw-um-submission')
    .service('policyActionUtil', PolicyActionUtil);
